import { render, staticRenderFns } from "./ExamItem.vue?vue&type=template&id=0fab743d&"
import script from "./ExamItem.vue?vue&type=script&lang=js&"
export * from "./ExamItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "pc/components/ExamItem.vue"
export default component.exports